import { APP_MODE_TYPES, appMode, hasActionCable, isKds, isKiosk, isPos } from 'src/config'
import Model, { GqlError, registerModel } from 'src/models/model'
import VueModel from 'src/models/VueModel'
import { defineAsyncComponent } from 'vue'

export const models = [
  import('src/models/archivable/ArchivableModel'),
  import('src/models/librariable/LibrariableLinkable'),
  import('src/models/generic/Generic'),

  import('src/models/circuit/Circuit'),
  import('src/models/site/Site'),

  import('src/models/page/Page'),
  import('src/models/page/Section'),
  import('src/models/page/Navigation'),
  import('src/models/page/ImageAsset'),
  import('src/models/news-item/NewsItem'),
  import('src/models/news-item/NewsItemClass'),
  import('src/models/print-template/PrintTemplate'),
  import('src/models/page/SassCompiler'),

  import('src/models/user-class/UserClass'),
  import('src/models/user-point/UserPoint'),

  import('src/models/user/User'),
  import('src/models/user/UpdatePaymentMethodUser'),
  import('src/models/user/UserEmployeeJobType'),
  import('src/models/user-movie/UserMovie'),
  import('src/models/user/UserStripeCustomer'),
  import('src/models/visit-review/VisitReview'),
  import('src/models/time-clock/TimeClockSession'),
  import('src/models/employee-job-type/EmployeeJobType'),

  import('src/models/access-control/Role'),
  import('src/models/access-control/RolePermission'),
  import('src/models/access-control/RolePermissionRecordRestriction'),
  import('src/models/access-control/Permission'),

  import('src/models/order/Order'),
  import('src/models/order/Tax'),
  import('src/models/activity/ActivityBooking'),
  import('src/models/order/CheckoutData'),
  import('src/models/order-item/OrderItem'),
  import('src/models/order-item/ItemOrderItem'),
  import('src/models/order-item/ItemOrderItemModifier'),
  import('src/models/payment/Payment'),
  import('src/models/payment/PaymentType'),
  import('src/models/booking-fee-type/BookingFeeType'),

  import('src/models/location/Location'),
  import('src/models/location/LocationGroup'),
  import('src/models/delivery-type/DeliveryType'),
  import('src/models/delivery-location/DeliveryLocation'),
  import('src/models/kitchen-display/KitchenDisplayType'),
  import('src/models/kitchen-display/KitchenDisplay'),

  import('src/models/discount/Discount'),
  import('src/models/voucher/VoucherType'),
  import('src/models/voucher/Voucher'),
  import('src/models/voucher/VoucherPackage'),
  import('src/models/voucher/IssuedVoucherPackage'),
  import('src/models/voucher/IssuedVoucherPackageVoucher'),

  import('src/models/gift-card/GiftCard'),

  import('src/models/membership-type/MembershipType'),
  import('src/models/membership-type/MembershipUserType'),
  import('src/models/membership-type/MembershipTier'),
  import('src/models/membership-type/MembershipPoint'),
  import('src/models/membership-type/MembershipVoucher'),
  import('src/models/membership-type/MembershipDiscount'),
  import('src/models/membership/Membership'),
  import('src/models/membership/MembershipInterval'),

  import('src/models/showing/Showing'),
  import('src/models/showing/PriceCard'),
  import('src/models/showing/ShowingBadge'),
  import('src/models/showing/TicketType'),

  import('src/models/showing/PriceCardItem'),
  import('src/models/package/ItemPackageItem'),
  import('src/models/package/ItemPackage'),

  import('src/models/ticket/Ticket'),

  import('src/models/movie/Movie'),
  import('src/models/movie/MovieTerm'),
  import('src/models/movie/MovieTermWeek'),
  import('src/models/movie/TitleClass'),

  import('src/models/screen/Screen'),
  import('src/models/screen/SeatChart'),
  import('src/models/screen/SeatChartAreaCategory'),

  import('src/models/dispute/Dispute'),
  import('src/models/dispute/DisputeEvidence'),

  import('src/models/item/Item'),
  import('src/models/item/ItemVariation'),
  import('src/models/item/ItemModifierSet'),
  import('src/models/item/ItemClass'),
  import('src/models/item/Category'),

  import('src/models/modifier-set/ModifierSet'),
  import('src/models/modifier-set/Modifier'),

  import('src/models/schedule/BookingWeek'),
  import('src/models/schedule/BookingWeekMovie'),

  import('src/models/pnl-data/PnlData'),

  import('src/models/box-office-report/Studio'),
  import('src/models/box-office-report/BoxOfficeReport'),
  import('src/models/settlement/StudioSettlement'),
  import('src/models/settlement/BoxOfficeReportSettlement'),

  import('src/models/transfer/Transfer'),
  import('src/models/transfer/TransferPayout'),

  import('src/models/schedule/TimeSlot'),
  import('src/models/schedule/SiteSchedule'),
  import('src/models/schedule/ShowingSlot'),
  import('src/models/schedule/PlanElement'),
  import('src/models/site-location-zone/SiteLocationZone'),
  import('src/models/card/Card'),

  import('src/models/register/RegisterStation'),
  import('src/models/register/RegisterClient'),
  import('src/models/register/RegisterType'),
  import('src/models/register/RegisterPage'),
  import('src/models/register/RegisterGrid'),
  import('src/models/register/RegisterButton'),

  import('src/models/kds/KdsClient'),

  import('src/models/hardware/Hardware'),

  import('src/models/client-version/ClientVersion'),

  import('src/models/report/ReportCategory'),
  import('src/models/report/Report'),
  import('src/models/report/ReportStatus'),
  import('src/models/report/ReportSchedule'),
  import('src/models/report/ReportElement'),
  import('src/models/report/ReportComponent'),
  import('src/models/report/Widget'),
  import('src/models/report/ReportChart'),
  import('src/models/report/ReportTable'),
  import('src/models/report/ReportTableColumn'),
  import('src/models/report/ReportView'),
  import('src/models/report/ReportHtml'),

  import('src/models/planning/TaskPlanning'),
  import('src/models/planning/CleanTask'),

  import('src/models/cash/CashTray'),
  import('src/models/cash/CashCount'),
  import('src/models/cash/CashSession'),
  import('src/models/cash/CashAdjustment'),
  import('src/models/cash/CashDeposit'),
  import('src/models/cash/CashDepositDrop'),
  import('src/models/cash/CashReconciliation'),

  import('src/models/job-logger/JobLog'),
  import('src/models/job-logger/JobLogType'),

  import('src/models/developer/Developer'),

  import('src/models/cea-card/CeaCard'),
  import('src/models/meerkat-movie/MeerkatMovie'),

  import('src/models/marketing/MarketingList'),

  import('src/models/subscription/MarketingSubscription'),
  import('src/models/subscription/UserMarketingSubscription'),
  import('src/models/subscription/Broadcast'),

  import('src/models/customerio/CustomerioBroadcast'),
  import('src/models/customerio/CustomerioSegment'),
  import('src/models/customerio/CustomerioSegmentTask'),
  import('src/models/customerio/CustomerioSegmentTaskAction'),
  import('src/models/external-ticketing/OauthApplication'),
  import('src/models/external-ticketing/ExternalTicketingClient'),

  import('src/models/support/SupportCategory'),
  import('src/models/support/SupportArticle'),

  import('src/models/unknown-payment/UnknownPayment'),

  import('src/models/page/CustomBlock'),

  import('src/models/inventory-item/InventoryItem'),
  import('src/models/inventory-item/InventoryItemUnit'),
  import('src/models/inventory-item/InventoryItemAdjustment'),
  import('src/models/inventory-item/InventoryItemBulkAdjustment'),

  import('src/models/inventory-recipe/InventoryRecipe'),
  import('src/models/inventory-recipe/InventoryRecipeTrigger'),
  import('src/models/inventory-recipe/InventoryRecipeItem'),

  import('src/models/inventory-supplier/InventorySupplier'),
  import('src/models/inventory-strategy/InventoryStrategy'),

  import('src/models/activity/Activity'),
  import('src/models/activity/ActivityCategory'),
  import('src/models/activity-layout/ActivityLayout'),
  import('src/models/activity-schedule/ActivitySchedule'),
  import('src/models/activity-schedule/ScheduleSlot'),
  import('src/models/activity-session/ActivitySession'),
  import('src/models/activity-space/ActivitySpace'),
  import('src/models/activity-ticket/ActivityTicket'),

  import('src/models/version/Version'),
  import('src/models/authorized-purchaser/AuthorizedPurchaser'),

  import('src/models/generic-form/FormEntry'),

  import('src/models/signage/SignageMediaItem'),
  import('src/models/signage/SignageMediaClass'),

  import('src/models/cinema-data-migration/CinemaDataMigration'),
  import('src/models/cinema-data-migration/CinemaDataMigrationData'),

  import('src/models/hardware/HardwareJob'),

  import('src/models/accounting/Account'),
  import('src/models/accounting/AccountSource'),
  import('src/models/accounting/JournalEntry'),
  import('src/models/accounting/AccountingDay'),

  import('src/models/model-export/ModelExport'),

  import('src/models/shortened-url/ShortenedUrl'),

  import('src/models/git/GitRelease'),

  import('src/models/configuration-audit/ConfigurationAudit'),

  import('src/models/account-manager/AccountManager'),

  import('src/models/payment-connector/PaymentConnectorConfiguration'),
  import('src/models/payment-connector/PaymentConnectorLog'),
  import('src/models/payment-connector/PaymentConnectorTransactionNumber'),

  import('src/models/price-tier/PriceTier'),
  import('src/models/price-tier/PriceTierPrice'),

  import('src/models/global-widget/GlobalWidget'),
  import('src/models/global-widget/GlobalWidgetBlock'),

  import('src/models/data-migration/DataMigration'),
  import('src/models/data-migration/DataMigrationSegment'),

  import('src/models/checkout-code/CheckoutCode'),
  import('src/models/pager-request/PagerRequestType'),
  import('src/models/pager-request/DeliveryLocationPagerRequest'),

  import('src/models/tip/TipPoolType'),
  import('src/models/tip/TipShareRule'),
  import('src/models/tip/TipPoolShare'),
  import('src/models/tip/TipPool'),
  import('src/models/tip/TipPoolTip'),
  import('src/models/tip/Tip'),
  import('src/models/tip/TipShare'),

  GqlError,

  import('src/models/ClientContext'),
  import('src/models/ClientConfig'),

  import('src/models/feature-flags/FeatureFlag')
]

export const modelTables = {
  screens: defineAsyncComponent(() => import('src/modules/admin/screen/ScreenTable')),
  'seat-charts': defineAsyncComponent(() => import('src/modules/admin/seat-chart/SeatChartConfigurationPage')),
  'showing-badges': defineAsyncComponent(() => import('src/modules/admin/showing-badge/ShowingBadgeTable')),
  'booking-fee-types': defineAsyncComponent(() => import('src/modules/admin/booking-fee-type/BookingFeePage')),
  'price-cards': defineAsyncComponent(() => import('src/modules/admin/price-card/PriceCardTable')),
  'ticket-types': defineAsyncComponent(() => import('src/modules/admin/ticket-type/TicketTypeTable')),
  'user-classes': defineAsyncComponent(() => import('src/modules/admin/user-class/UserClassTable')),
  items: defineAsyncComponent(() => import('src/modules/admin/item/ItemTable')),
  categories: defineAsyncComponent(() => import('src/modules/admin/category/CategoryTable')),
  modifiers: defineAsyncComponent(() => import('src/modules/admin/modifier/ModifierTable')),
  'modifier-sets': defineAsyncComponent(() => import('src/modules/admin/modifier-set/ModifierSetTable')),
  'membership-types': defineAsyncComponent(() => import('src/modules/admin/membership-type/MembershipTypeTable')),
  location: defineAsyncComponent(() => import('src/modules/admin/location/LocationPage')),
  locations: defineAsyncComponent(() => import('src/modules/admin/location/LocationTable')),
  'location-groups': defineAsyncComponent(() => import('src/modules/admin/location/LocationGroupTable')),
  delivery: defineAsyncComponent(() => import('src/modules/admin/delivery-type/DeliveryPage')),
  'delivery-types': defineAsyncComponent(() => import('src/modules/admin/delivery-type/DeliveryTypeTable')),
  'delivery-locations': defineAsyncComponent(() => import('src/modules/admin/delivery-location/DeliveryLocationTable')),
  kitchen: defineAsyncComponent(() => import('src/modules/admin/kitchen-display/KitchenPage')),
  'kitchen-display-types': defineAsyncComponent(() => import('src/modules/admin/kitchen-display/KitchenDisplayTypeTable')),
  'kitchen-displays': defineAsyncComponent(() => import('src/modules/admin/kitchen-display/KitchenDisplayTable')),
  discounts: defineAsyncComponent(() => import('src/modules/admin/discount/DiscountTable')),
  'voucher-types': defineAsyncComponent(() => import('src/modules/admin/voucher-type/VoucherTypeTable')),
  stations: defineAsyncComponent(() => import('src/modules/admin/register-station/StationConfigurationPage')),
  'register-types': defineAsyncComponent(() => import('src/modules/admin/register-type/RegisterTypeTable')),
  'register-grids': defineAsyncComponent(() => import('src/modules/admin/register-grid/RegisterGridTable')),
  'cash-trays': defineAsyncComponent(() => import('src/modules/admin/cash/CashTrayTable')),
  movies: defineAsyncComponent(() => import('src/modules/admin/movie/MovieTable')),
  'movie-terms': defineAsyncComponent(() => import('src/modules/admin/movie/MovieTermsTable')),
  users: defineAsyncComponent(() => import('src/modules/admin/user/UserTable')),
  memberships: defineAsyncComponent(() => import('src/modules/admin/membership/MembershipTable')),
  vouchers: defineAsyncComponent(() => import('src/modules/admin/voucher/VoucherTable')),
  cards: defineAsyncComponent(() => import('src/modules/admin/card/CardTable')),
  'gift-cards': defineAsyncComponent(() => import('src/modules/admin/gift-card/GiftCardTable')),
  'voucher-packages': defineAsyncComponent(() => import('src/modules/admin/voucher-package/VoucherPackageTable')),
  orders: defineAsyncComponent(() => import('src/modules/admin/order/OrderTable')),
  payments: defineAsyncComponent(() => import('src/modules/admin/payment/PaymentTable')),
  'site-schedules': defineAsyncComponent(() => import('src/modules/admin/site-schedule/SiteScheduleTable')),
  'box-office-reports': defineAsyncComponent(() => import('src/modules/admin/box-office-report/BoxOfficeReportTable')),
  'box-office-report-settlements': defineAsyncComponent(() => import('src/modules/admin/settlement/BoxOfficeReportSettlementTable')),
  studios: defineAsyncComponent(() => import('src/modules/admin/studio/StudioTable')),
  'studio-settlements': defineAsyncComponent(() => import('src/modules/admin/settlement/StudioSettlementTable')),
  'plan-elements': defineAsyncComponent(() => import('src/modules/admin/plan-element/PlanElementTable')),
  'booking-weeks': defineAsyncComponent(() => import('src/modules/admin/booking-week/BookingWeekTable')),
  showings: defineAsyncComponent(() => import('src/modules/admin/showing/ShowingTable')),
  'news-items': defineAsyncComponent(() => import('src/modules/admin/news-item/NewsItemTable')),
  'news-item-classes': defineAsyncComponent(() => import('src/modules/admin/news-item/NewsItemClassTable')),
  pages: defineAsyncComponent(() => import('src/modules/admin/page/PageConfigurationPage')),
  navigations: defineAsyncComponent(() => import('src/modules/admin/navigation/NavigationTable')),
  taxes: defineAsyncComponent(() => import('src/modules/admin/tax/TaxTable')),
  'site-location-zones': defineAsyncComponent(() => import('src/modules/admin/site-location-zone/SiteLocationZoneTable')),
  hardwares: defineAsyncComponent(() => import('src/modules/admin/hardware/HardwareIndex')),
  'time-slots': defineAsyncComponent(() => import('src/modules/admin/time-slot/TimeSlotIndex')),
  'default-price-cards': defineAsyncComponent(() => import('src/modules/admin/price-card/DefaultPriceCards')),
  'item-classes': defineAsyncComponent(() => import('src/modules/admin/item-class/ItemClassTable')),
  transfers: defineAsyncComponent(() => import('src/modules/admin/transfer/TransferTable')),
  disputes: defineAsyncComponent(() => import('src/modules/admin/payment/PaymentDisputeTable')),
  'job-logs': defineAsyncComponent(() => import('src/modules/admin/job-logger/JobLoggerTable')),
  'title-classes': defineAsyncComponent(() => import('src/modules/admin/title-class/TitleClassTable')),
  'report-categories': defineAsyncComponent(() => import('src/modules/admin/report-category/ReportCategoryTable')),
  'report-schedules': defineAsyncComponent(() => import('src/modules/admin/report-schedule/ReportScheduleTable')),
  'marketing-lists': defineAsyncComponent(() => import('src/modules/admin/marketing/MarketingListTable')),
  'client-versions': defineAsyncComponent(() => import('src/modules/admin/client-version/ClientVersionTable')),
  packages: defineAsyncComponent(() => import('src/modules/admin/package/PackageTable')),
  'marketing-subscriptions': defineAsyncComponent(() => import('src/modules/admin/subscription/MarketingSubscriptionTable')),
  broadcasts: defineAsyncComponent(() => import('src/modules/admin/subscription/BroadcastTable')),
  'customerio-segment-tasks': defineAsyncComponent(() => import('src/modules/admin/customerio/CustomerioSegmentTaskTable')),
  'support-articles': defineAsyncComponent(() => import('src/modules/admin/support-article/SupportArticleTable')),
  'oauth-applications': defineAsyncComponent(() => import('src/modules/admin/external-ticketing/OauthApplicationTable')),
  'external-ticketing-clients': defineAsyncComponent(() => import('src/modules/admin/external-ticketing/ExternalTicketingClientTable')),
  'unknown-payments': defineAsyncComponent(() => import('src/modules/admin/developer/UnknownPaymentsTable')),
  'custom-blocks': defineAsyncComponent(() => import('src/modules/admin/custom-block/CustomBlockTable')),
  teams: defineAsyncComponent(() => import('src/modules/admin/team/TeamTable')),
  'form-entries': defineAsyncComponent(() => import('src/modules/admin/form-entry/FormEntryTable')),
  'signage-media-items': defineAsyncComponent(() => import('src/modules/admin/signage/SignageMediaTable')),
  'signage-media-classes': defineAsyncComponent(() => import('src/modules/admin/signage/SignageMediaClassTable')),
  'visit-reviews': defineAsyncComponent(() => import('src/modules/admin/visit-review/VisitReviewTable')),
  'inventory-items': defineAsyncComponent(() => import('src/modules/admin/inventory-item/InventoryItemTable')),
  'inventory-recipes': defineAsyncComponent(() => import('src/modules/admin/inventory-recipe/InventoryRecipeTable')),
  'inventory-suppliers': defineAsyncComponent(() => import('src/modules/admin/inventory-supplier/InventorySupplierTable')),
  'inventory-strategies': defineAsyncComponent(() => import('src/modules/admin/inventory-strategy/InventoryStrategyTable')),
  'inventory-bulk-adjustments': defineAsyncComponent(() => import('src/modules/admin/inventory-item/InventoryItemBulkAdjustmentTable')),
  activities: defineAsyncComponent(() => import('src/modules/admin/activity/ActivityTable')),
  'activity-layouts': defineAsyncComponent(() => import('src/modules/admin/activity-layout/ActivityLayoutTable')),
  'activity-schedules': defineAsyncComponent(() => import('src/modules/admin/activity-schedule/ActivityScheduleTable')),
  'activity-spaces': defineAsyncComponent(() => import('src/modules/admin/activity-space/ActivitySpaceTable')),
  'time-clock-sessions': defineAsyncComponent(() => import('src/modules/admin/time-clock-session/TimeClockSessionTable')),
  'payment-types': defineAsyncComponent(() => import('src/modules/admin/payment-type/PaymentTypeTable')),
  'cinema-data-migrations': defineAsyncComponent(() => import('src/modules/admin/cinema-data-migration/CinemaDataMigrationTable')),
  'data-migrations': defineAsyncComponent(() => import('src/modules/admin/data-migration/DataMigrationTable')),
  'print-templates': defineAsyncComponent(() => import('src/modules/admin/site/PrintTemplateSettingsForm')),
  'hardware-jobs': defineAsyncComponent(() => import('src/modules/admin/hardware/HardwareJobTable')),
  accounts: defineAsyncComponent(() => import('src/modules/admin/account/AccountTable')),
  'journal-entries': defineAsyncComponent(() => import('src/modules/admin/journal-entry/JournalEntryTable')),
  exports: defineAsyncComponent(() => import('src/modules/admin/model-export/ModelExportTable')),
  'shortened-urls': defineAsyncComponent(() => import('src/modules/admin/shortened-url/ShortenedUrlTable')),
  'employee-job-types': defineAsyncComponent(() => import('src/modules/admin/employee-job-type/EmployeeJobTypeTable')),
  roles: defineAsyncComponent(() => import('src/modules/admin/role/RoleTable')),
  'payment-connectors': defineAsyncComponent(() => import('src/modules/admin/payment-connector/PaymentConnectorConfigurationTable')),
  'developer-payment-connectors': defineAsyncComponent(() => import('src/modules/admin/developer/PaymentConnectorGlobalConfiguration')),
  'accounting-days': defineAsyncComponent(() => import('src/modules/admin/accounting-day/AccountingDayTable')),
  'item-variation-price-tiers': defineAsyncComponent(() => import('src/modules/admin/item-variation/ItemVariationPriceTierTable')),
  'price-tiers': defineAsyncComponent(() => import('src/modules/admin/price-tier/PriceTierTable')),
  'global-widgets': defineAsyncComponent(() => import('src/modules/admin/global-widget/GlobalWidgetTable')),
  'pager-request-types': defineAsyncComponent(() => import('src/modules/admin/pager-request/PagerRequestTypeTable')),
  'tip-pool-types': defineAsyncComponent(() => import('src/modules/admin/tip/TipPoolTypeTable')),
  'tip-share-rules': defineAsyncComponent(() => import('src/modules/admin/tip/TipShareRuleTable')),
  'tip-pools': defineAsyncComponent(() => import('src/modules/admin/tip/TipPoolTable')),
  'tip-shares': defineAsyncComponent(() => import('src/modules/admin/tip/TipShareTable')),
  'tip-pool-tips': defineAsyncComponent(() => import('src/modules/admin/tip/TipPoolTipTable')),
  tips: defineAsyncComponent(() => import('src/modules/admin/tip/TipTable')),
  'tip-settings': defineAsyncComponent(() => import('src/modules/admin/tip/TipSettingsPage')),
  tipping: defineAsyncComponent(() => import('src/modules/admin/tip/TipOperationsPage'))
}

export const modelIndexNames = _.keys(modelTables)

export const modelForms = {
  screens: defineAsyncComponent(() => import('src/modules/admin/screen/ScreenForm')),
  'seat-charts': defineAsyncComponent(() => import('src/modules/admin/seat-chart/SeatChartForm')),
  'showing-badges': defineAsyncComponent(() => import('src/modules/admin/showing-badge/ShowingBadgeForm')),
  'booking-fee-types': defineAsyncComponent(() => import('src/modules/admin/booking-fee-type/BookingFeeTypeForm')),
  'price-cards': defineAsyncComponent(() => import('src/modules/admin/price-card/PriceCardForm')),
  'ticket-types': defineAsyncComponent(() => import('src/modules/admin/ticket-type/TicketTypeForm')),
  'user-classes': defineAsyncComponent(() => import('src/modules/admin/user-class/UserClassForm')),
  items: defineAsyncComponent(() => import('src/modules/admin/item/ItemForm')),
  categories: defineAsyncComponent(() => import('src/modules/admin/category/CategoryForm')),
  modifiers: defineAsyncComponent(() => import('src/modules/admin/modifier/ModifierForm')),
  'modifier-sets': defineAsyncComponent(() => import('src/modules/admin/modifier-set/ModifierSetForm')),
  'membership-types': defineAsyncComponent(() => import('src/modules/admin/membership-type/MembershipTypeForm')),
  locations: defineAsyncComponent(() => import('src/modules/admin/location/LocationForm')),
  'location-groups': defineAsyncComponent(() => import('src/modules/admin/location/LocationGroupForm')),
  'kitchen-display-types': defineAsyncComponent(() => import('src/modules/admin/kitchen-display/KitchenDisplayTypeForm')),
  'kitchen-displays': defineAsyncComponent(() => import('src/modules/admin/kitchen-display/KitchenDisplayForm')),
  'delivery-locations': defineAsyncComponent(() => import('src/modules/admin/delivery-location/DeliveryLocationForm')),
  discounts: defineAsyncComponent(() => import('src/modules/admin/discount/DiscountForm')),
  'voucher-types': defineAsyncComponent(() => import('src/modules/admin/voucher-type/VoucherTypeForm')),
  'voucher-packages': defineAsyncComponent(() => import('src/modules/admin/voucher-package/VoucherPackageForm')),
  stations: defineAsyncComponent(() => import('src/modules/admin/register-station/RegisterStationForm')),
  'register-stations': defineAsyncComponent(() => import('src/modules/admin/register-station/RegisterStationForm')),
  'register-types': defineAsyncComponent(() => import('src/modules/admin/register-type/RegisterTypeForm')),
  'register-grids': defineAsyncComponent(() => import('src/modules/admin/register-grid/RegisterGridForm')),
  movies: defineAsyncComponent(() => import('src/modules/admin/movie/MovieForm')),
  'movie-terms': defineAsyncComponent(() => import('src/modules/admin/movie/MovieTermsForm')),
  users: defineAsyncComponent(() => import('src/modules/admin/user/UserForm')),
  memberships: defineAsyncComponent(() => import('src/modules/admin/membership/MembershipForm')),
  vouchers: defineAsyncComponent(() => import('src/modules/admin/voucher/VoucherForm')),
  cards: defineAsyncComponent(() => import('src/modules/admin/card/CardForm')),
  'gift-cards': defineAsyncComponent(() => import('src/modules/admin/gift-card/GiftCardForm')),
  orders: defineAsyncComponent(() => import('src/modules/admin/order/OrderForm')),
  payments: defineAsyncComponent(() => import('src/modules/admin/payment/PaymentForm')),
  'site-schedules': defineAsyncComponent(() => import('src/modules/admin/site-schedule/SiteScheduleForm')),
  'box-office-reports': defineAsyncComponent(() => import('src/modules/admin/box-office-report/BoxOfficeReportForm')),
  studios: defineAsyncComponent(() => import('src/modules/admin/studio/StudioForm')),
  'plan-elements': defineAsyncComponent(() => import('src/modules/admin/plan-element/PlanElementForm')),
  'booking-weeks': defineAsyncComponent(() => import('src/modules/admin/booking-week/BookingWeekForm')),
  'news-items': defineAsyncComponent(() => import('src/modules/admin/news-item/NewsItemForm')),
  'news-item-classes': defineAsyncComponent(() => import('src/modules/admin/news-item/NewsItemClassForm')),
  pages: defineAsyncComponent(() => import('src/modules/admin/page/PageForm')),
  navigations: defineAsyncComponent(() => import('src/modules/admin/navigation/NavigationForm')),
  taxes: defineAsyncComponent(() => import('src/modules/admin/tax/TaxForm')),
  'site-location-zones': defineAsyncComponent(() => import('src/modules/admin/site-location-zone/SiteLocationZoneForm')),
  'item-classes': defineAsyncComponent(() => import('src/modules/admin/item-class/ItemClassForm')),
  'job-logs': defineAsyncComponent(() => import('src/modules/admin/job-logger/JobLoggerForm')),
  showings: defineAsyncComponent(() => import('src/modules/admin/showing/ShowingForm')),
  'title-classes': defineAsyncComponent(() => import('src/modules/admin/title-class/TitleClassForm')),
  'edit-reports': defineAsyncComponent(() => import('src/modules/admin/report/ReportForm')),
  'report-categories': defineAsyncComponent(() => import('src/modules/admin/report-category/ReportCategoryForm')),
  'report-schedules': defineAsyncComponent(() => import('src/modules/admin/report-schedule/ReportScheduleForm')),
  'client-versions': defineAsyncComponent(() => import('src/modules/admin/client-version/ClientVersionForm')),
  'support-articles': defineAsyncComponent(() => import('src/modules/admin/support-article/SupportArticleForm')),
  transfers: defineAsyncComponent(() => import('src/modules/admin/transfer/TransferForm')),
  hardwares: defineAsyncComponent(() => import('src/modules/admin/hardware/HardwareForm')),
  'signage-media-items': defineAsyncComponent(() => import('src/modules/admin/signage/SignageMediaForm')),
  'signage-media-classes': defineAsyncComponent(() => import('src/modules/admin/signage/SignageMediaClassForm')),
  'visit-reviews': defineAsyncComponent(() => import('src/modules/admin/visit-review/VisitReviewForm')),
  'time-clock-sessions': defineAsyncComponent(() => import('src/modules/admin/time-clock-session/TimeClockSessionForm')),
  'hardware-jobs': defineAsyncComponent(() => import('src/modules/admin/hardware/HardwareJobForm')),
  'shortened-urls': defineAsyncComponent(() => import('src/modules/admin/shortened-url/ShortenedUrlForm')),
  'employee-job-types': defineAsyncComponent(() => import('src/modules/admin/employee-job-type/EmployeeJobTypeForm')),
  roles: defineAsyncComponent(() => import('src/modules/admin/role/RoleForm')),
  'global-widgets': defineAsyncComponent(() => import('src/modules/admin/global-widget/GlobalWidgetForm')),
  'pager-request-types': defineAsyncComponent(() => import('src/modules/admin/pager-request/PagerRequestTypeForm')),
  'tip-pool-types': defineAsyncComponent(() => import('src/modules/admin/tip/TipPoolTypeForm')),
  'tip-share-rules': defineAsyncComponent(() => import('src/modules/admin/tip/TipShareRuleForm')),
  'tip-pools': defineAsyncComponent(() => import('src/modules/admin/tip/TipPoolForm')),
  'tip-shares': defineAsyncComponent(() => import('src/modules/admin/tip/TipShareForm')),
  'tip-pool-tips': defineAsyncComponent(() => import('src/modules/admin/tip/TipPoolTipForm')),
  tips: defineAsyncComponent(() => import('src/modules/admin/tip/TipForm'))
}

export const modelPageNames = _.keys(modelForms)

export function buildConfigs (appMode) {
  let skipContext = false
  let contextConfig = {
    // Note: currently the API will automatically return no permissions for non-employees.
    permittedFrontendActions: true
  }

  let clientConfigConfig = {
    showingBadges: 'default',
    screens: 'default',
    priceCards: {
      priceCardItems: 'default',
      showingBadges: 'default'
    },
    priceCardItems: 'default',
    itemPackages: {
      itemPackageItems: {
        ticketType: true,
        itemVariation: true
      },
      discounts: true
    },
    itemPackageItems: 'default',
    paymentTypes: 'default',
    roles: 'default',
    activities: {
      activityCategories: 'default',
      ticketTypes: 'default',
      itemPackages: 'default',
      fromPrices: true,
      maxActivitySpaceCapacity: true
    },
    activitySpaces: 'default'
  }

  // Note that we are comparing the function argument `appMode`, not the config constant
  if (appMode === APP_MODE_TYPES.ADMIN || appMode === APP_MODE_TYPES.REGISTER || appMode === APP_MODE_TYPES.KIOSK || appMode === APP_MODE_TYPES.KDS || appMode === APP_MODE_TYPES.ROAM) {
    contextConfig = {
      ...contextConfig,

      currentUser: {
        authorizedCircuits: {
          fields: ['id', 'name', 'migratedTo']
        },
        userMovies: true,
        watchedMovieIds: true,
        compactTablePreference: true,
        plainTableContentPreference: true,
        authorizedSites: {
          fields: ['id', 'name', 'isLibrary'],
          circuit: {
            fields: ['id', 'name']
          }
        },
        dashboard: {
          fields: ['id', 'circuitId']
        },
        intercomAuthenticationToken: true,
        intercomIndyUserId: true,
        userEmployeeJobTypes: {
          employeeJobType: {
            fields: ['id', 'name', 'siteId']
          }
        }
      }
    }

    clientConfigConfig = {
      ...clientConfigConfig,
      bookingFeeTypes: {
        membershipTypes: {
          fields: ['id', 'name']
        },
        membershipTierIds: true,
        showingBadges: {
          fields: ['id', 'name']
        },
        taxes: {
          fields: ['id', 'name']
        },
        ticketTypes: {
          fields: ['id', 'name']
        },
        deliveryLocations: {
          fields: ['id', 'name']
        }
      },
      timeSlots: 'default',
      userClasses: 'default',
      voucherTypes: {
        taxes: 'default',
        items: 'default',
        itemVariations: 'default',
        itemClasses: 'default',
        movieIds: 'default',
        showingIds: 'default',
        activityIds: 'default',
        activitySessionIds: 'default',
        titleClasses: 'default',
        ticketTypes: 'default',
        sites: 'default',
        membershipTypes: 'default'
      },
      voucherPackages: {
        voucherTypes: 'default',
        taxes: 'default'
      },
      ticketTypes: {
        userClass: 'default',
        membershipType: 'default',
        seatChartAreaCategoryIds: true
      },
      categories: {
        items: true,
        itemPackages: true
      },

      membershipTypes: {
        membershipUserTypes: {
          membershipType: 'default',
          userClass: 'default'
        },
        membershipTiers: {
          membershipType: 'default'
        },
        membershipPoints: {
          membershipType: 'default',
          membershipTierIds: 'default'
        },
        membershipVouchers: {
          membershipType: 'default',
          membershipTiers: {
            fields: ['id', 'name']
          },
          membershipTierIds: 'default',
          sites: 'default'
        },
        membershipDiscounts: {
          membershipType: 'default',
          membershipTiers: {
            fields: ['id', 'name']
          },
          membershipTierIds: 'default',
          sites: 'default'
        },
        sites: 'default'
      },
      defaultMembershipType: {
        membershipVouchers: {
          membershipTierIds: 'default',
          voucherType: {
            items: 'default',
            itemVariations: 'default',
            itemClasses: 'default',
            movieIds: 'default',
            showingIds: 'default',
            activityIds: 'default',
            activitySessionIds: 'default',
            titleClasses: 'default',
            ticketTypes: 'default',
            sites: 'default'
          },
          membershipTiers: {
            fields: ['id', 'name']
          },
          sites: 'default'
        },
        membershipDiscounts: {
          discount: 'default',
          membershipTiers: {
            fields: ['id', 'name']
          },
          membershipTierIds: 'default',
          sites: 'default'
        }
      },
      discounts: {
        items: 'default',
        itemVariations: 'default',
        itemClasses: 'default',
        movieIds: 'default',
        showingIds: 'default',
        titleClasses: 'default',
        ticketTypes: 'default',
        membershipTypes: 'default',
        voucherTypes: 'default',
        sites: 'default'
      },
      items: {
        taxes: 'default',
        itemClass: 'default',
        category: 'default',
        preparationCategory: 'default',
        itemVariations: 'default',
        locations: 'default',
        itemModifierSets: {
          modifierSet: 'default',
          defaultModifiers: 'default'
        }
      },
      itemVariations: {
        inventoryRecipes: {
          inventoryRecipeTriggers: true
        }
      },
      modifiers: {
        inventoryRecipes: {
          inventoryRecipeTriggers: true
        },
        modifierSets: true
      },
      modifierSets: {
        modifiers: {
          inventoryRecipes: {
            inventoryRecipeTriggers: true
          }
        }
      },
      taxes: {
        sites: 'default'
      },
      locations: {
        locationGroup: true
      },
      deliveryTypes: 'default',
      deliveryLocations: {
        screens: 'default'
      },
      kitchenDisplayTypes: 'default',
      kitchenDisplays: {
        kitchenDisplayType: {
          fields: ['id', 'name']
        },
        locations: {
          fields: ['id', 'name'],
          locationGroup: {
            fields: ['id', 'name']
          }
        }
      },
      itemClasses: 'default',

      sites: {
        fields: ['id', 'name', 'isLibrary', 'siteLocationZone', 'iso31661', 'deletedAt']
      },
      currentCircuit: {
        sites: true,
        reservedSeatingShowingBadge: true,
        defaultDashboard: {
          fields: ['id']
        }
      },

      registerStations: {
        registerType: true,
        hardware: 'default'
      },
      registerTypes: {
        registerPages: {
          registerGrid: true,
          categories: true,
          category: true,
          location: true,
          activity: true
        },
        customerDisplayMediaClass: true,
        stripeTerminalLocationId: true
      },
      registerGrids: {
        registerButtons: {
          item: 'default',
          itemVariation: 'default',
          voucherType: 'default',
          voucherPackage: 'default',
          discount: 'default',
          discounts: 'default',
          itemPackage: 'default'
        }
      },
      siteLocationZones: 'default',
      activeMarketingSubscriptions: 'default',
      marketingSubscriptions: 'default'
    }
  }

  if (appMode === APP_MODE_TYPES.ADMIN) {
    clientConfigConfig = {
      ...clientConfigConfig,

      locationGroups: 'default',
      siteSchedules: 'default',
      screens: {
        showingBadges: true,
        seatChart: {
          seatChart: true
        }
      },
      deliveryLocations: {
        screens: 'default',
        pagerRequestTypes: 'default'
      },
      pagerRequestTypes: 'default',
      seatChartAreaCategories: 'default',
      priceTiers: 'default',
      employeeJobTypes: 'default',
      titleClasses: 'default',
      signageMediaClasses: 'default',
      reportComponents: 'default',
      regionReportComponents: 'default',

      currentCircuit: {
        userPinLength: true,
        sites: true,
        membershipTaxes: true,
        locations: {
          locationGroup: {
            site: true
          }
        },
        reservedSeatingShowingBadge: true,
        customerioWorkspaceIsConfigured: true
      },
      currentSite: {
        currentAuditLevels: true,
        defaultPriceCards: 'default',
        friendlyHostname: true,
        hostname: true,
        transformedStyles: true,
        defaultDashboard: {
          fields: ['id']
        },
        inventoryItemBaseUnits: true,
        pnlConfig: true,
        activeInventoryStrategy: {
          locations: true,
          registerStations: true,
          itemClasses: true
        },
        inventoryStrategies: {
          locations: true,
          registerStations: true,
          itemClasses: true
        },
        polarisEnabled: true
      },
      sites: {
        fields: ['id', 'name', 'hostname', 'isLibrary', 'city', 'state', 'consumerConfig', 'siteLocationZone', 'iso31661', 'displayOrder', 'deletedAt'],
        activeInventoryStrategy: {
          locations: true,
          registerStations: true,
          itemClasses: true
        }
      },
      itemClasses: {
        taxes: 'default'
      },
      inventoryItems: {
        inventoryItemUnits: true,
        inventorySuppliers: true,
        itemClass: true
      },
      publishedPages: 'default',
      publishedPrintTemplates: 'default',
      newsItemClasses: 'default',
      publishedNewsItems: 'default'
    }
  }

  if (appMode === APP_MODE_TYPES.REGISTER || appMode === APP_MODE_TYPES.KIOSK) {
    contextConfig = {
      ...contextConfig,

      itemClasses: 'default',
      currentRegisterClient: {
        registerStation: 'default'
      }
    }

    clientConfigConfig = {
      ...clientConfigConfig,
      publishedPrintTemplates: 'default',
      currentCircuit: {
        userPinLength: true,
        membershipTaxes: true,
        hasMembershipVouchers: true
      },
      currentSite: {
        ticketTaxes: true,
        dayPassTaxes: true,
        exchangeFeeTaxes: true,
        surchargeFeeTaxes: true,
        enabledSignageMediaMovies: {
          allDatesWithPublicShowing: true
        },
        enabledSignageMediaItems: {
          signageMediaClass: 'default'
        },
        activeInventoryStrategy: {
          locations: true,
          registerStations: true,
          itemClasses: true
        },
        inventoryStrategies: {
          locations: true,
          registerStations: true,
          itemClasses: true
        }
      },
      sites: {
        fields: ['id', 'name', 'consumerConfig']
      },
      seatChartAreaCategories: {
        ticketTypes: 'default'
      },
      inventoryItems: {
        inventoryItemUnits: true,
        inventorySuppliers: true,
        itemClass: true
      },
      signageMediaClasses: true,
      registerTypes: {
        transformedStyles: true,
        registerPages: {
          registerGrid: true,
          categories: true,
          category: true,
          location: true,
          activity: true
        },
        customerDisplayMediaClass: true,
        stripeTerminalLocationId: true
      },
      titleClasses: 'default',
      categories: {
        items: true,
        itemPackages: true,
        membershipTypes: {
          fields: ['id', 'name']
        },
        membershipTierIds: true,
        showingBadges: {
          fields: ['id', 'name']
        }
      },
      employeeJobTypes: 'default'
    }
  }

  if (appMode === APP_MODE_TYPES.KDS || appMode === APP_MODE_TYPES.ROAM) {
    contextConfig = {
      ...contextConfig,
      currentKdsClient: {
        kitchenDisplay: {
          kitchenDisplayType: 'default',
          locations: 'default'
        }
      }
    }

    clientConfigConfig = {
      ...clientConfigConfig,
      currentSite: 'default'
    }
  }

  if (appMode === APP_MODE_TYPES.CONSUMER) {
    contextConfig = {
      ...contextConfig,
      currentUser: {
        userClass: true,
        userStripeCustomers: 'default',
        userMovies: true,
        watchedMovieIds: true,
        seatPreferences: true,
        itemPreferences: true,
        giftCards: {
          circuit: {
            fields: ['id']
          }
        },
        membership: {
          members: {
            userClass: true,
            membershipType: {
              membershipVouchers: {
                membershipTierIds: 'default',
                voucherType: {
                  items: 'default',
                  itemVariations: 'default',
                  itemClasses: 'default',
                  movieIds: 'default',
                  showingIds: 'default',
                  activityIds: 'default',
                  activitySessionIds: 'default',
                  titleClasses: 'default',
                  ticketTypes: 'default',
                  sites: 'default'
                },
                membershipTiers: {
                  fields: ['id', 'name']
                },
                sites: 'default'
              },
              membershipDiscounts: {
                discount: 'default',
                membershipTiers: {
                  fields: ['id', 'name']
                },
                membershipTierIds: 'default',
                sites: 'default'
              },
              membershipPoints: {
                membershipType: 'default',
                membershipTierIds: 'default',
                membershipTiers: {
                  fields: ['id', 'name']
                },
                sites: 'default'
              }
            },
            membershipTier: true,
            vouchers: {
              voucherType: {
                items: 'default',
                itemVariations: 'default',
                itemClasses: 'default',
                movieIds: 'default',
                showingIds: 'default',
                activityIds: 'default',
                activitySessionIds: 'default',
                titleClasses: 'default',
                ticketTypes: 'default',
                sites: 'default'
              }
            }
          },
          owner: {
            id: true
          }
        },
        membershipType: {
          membershipVouchers: {
            membershipTierIds: 'default',
            voucherType: {
              items: 'default',
              itemVariations: 'default',
              itemClasses: 'default',
              movieIds: 'default',
              showingIds: 'default',
              activityIds: 'default',
              activitySessionIds: 'default',
              titleClasses: 'default',
              ticketTypes: 'default',
              sites: 'default'
            },
            membershipTiers: {
              fields: ['id', 'name']
            },
            sites: {
              fields: ['id', 'name']
            }
          },
          membershipDiscounts: {
            discount: 'default',
            membershipTiers: {
              fields: ['id', 'name']
            },
            membershipTierIds: 'default',
            sites: 'default'
          },
          membershipPoints: {
            membershipType: 'default',
            membershipTierIds: 'default',
            membershipTiers: {
              fields: ['id', 'name']
            },
            sites: 'default'
          }
        },
        card: {
          humanUid: 'default'
        },
        membershipTier: true,
        purchasers: {},
        purchasees: {
          userClass: true,
          membershipType: {
            membershipVouchers: {
              membershipTierIds: 'default',
              voucherType: {
                items: 'default',
                itemVariations: 'default',
                itemClasses: 'default',
                movieIds: 'default',
                showingIds: 'default',
                activityIds: 'default',
                activitySessionIds: 'default',
                titleClasses: 'default',
                ticketTypes: 'default'
              },
              membershipTiers: {
                fields: ['id', 'name']
              },
              sites: 'default'
            },
            membershipDiscounts: {
              discount: 'default',
              membershipTiers: {
                fields: ['id', 'name']
              },
              membershipTierIds: 'default',
              sites: 'default'
            }
          },
          membership: {
            id: true,
            state: true
          },
          vouchers: {
            voucherType: {
              items: 'default',
              itemVariations: 'default',
              itemClasses: 'default',
              movieIds: 'default',
              showingIds: 'default',
              activityIds: 'default',
              activitySessionIds: 'default',
              titleClasses: 'default',
              ticketTypes: 'default',
              sites: 'default'
            }
          }
        },
        vouchers: {
          voucherType: {
            items: 'default',
            itemVariations: 'default',
            itemClasses: 'default',
            movieIds: 'default',
            showingIds: 'default',
            activityIds: 'default',
            activitySessionIds: 'default',
            titleClasses: 'default',
            ticketTypes: 'default',
            sites: 'default'
          }
        },
        userMarketingSubscriptions: 'default'
      }
    }

    clientConfigConfig = {
      ...clientConfigConfig,

      bookingFeeTypes: {
        membershipTypes: {
          fields: ['id', 'name']
        },
        membershipTierIds: true,
        showingBadges: {
          fields: ['id', 'name']
        },
        taxes: {
          fields: ['id', 'name']
        },
        ticketTypes: {
          fields: ['id', 'name']
        },
        deliveryLocations: {
          fields: ['id', 'name']
        }
      },
      seatChartAreaCategories: {
        ticketTypes: 'default'
      },
      pagerRequestTypes: 'default',
      timeSlots: 'default',
      userClasses: 'default',
      voucherTypes: {
        items: 'default',
        itemVariations: 'default',
        itemClasses: 'default',
        movieIds: 'default',
        showingIds: 'default',
        activityIds: 'default',
        activitySessionIds: 'default',
        titleClasses: 'default',
        ticketTypes: 'default',
        sites: 'default',
        membershipTypeIds: true
      },
      voucherPackages: {
        voucherTypes: 'default',
        taxes: 'default'
      },
      ticketTypes: {
        userClass: 'default',
        membershipType: 'default'
      },
      itemClasses: 'default',
      titleClasses: 'default',
      categories: {
        items: true,
        itemPackages: true,
        membershipTypes: {
          fields: ['id', 'name']
        },
        membershipTierIds: true,
        showingBadges: {
          fields: ['id', 'name']
        }
      },

      membershipTypes: {
        membershipUserTypes: {
          membershipType: 'default',
          userClass: 'default'
        },
        membershipTiers: {
          membershipType: 'default'
        },
        membershipPoints: {
          membershipType: 'default',
          membershipTierIds: 'default',
          membershipTiers: {
            fields: ['id', 'name']
          },
          sites: 'default'
        },
        membershipVouchers: {
          membershipTierIds: 'default',
          membershipType: 'default',
          membershipTiers: {
            fields: ['id', 'name']
          },
          sites: 'default'
        },
        membershipDiscounts: {
          membershipType: 'default',
          membershipTiers: {
            fields: ['id', 'name']
          },
          membershipTierIds: 'default',
          sites: 'default'
        },
        sites: 'default'
      },
      defaultMembershipType: {
        membershipVouchers: {
          membershipTierIds: 'default',
          voucherType: {
            items: 'default',
            itemVariations: 'default',
            itemClasses: 'default',
            movieIds: 'default',
            showingIds: 'default',
            activityIds: 'default',
            activitySessionIds: 'default',
            titleClasses: 'default',
            ticketTypes: 'default'
          },
          membershipTiers: {
            fields: ['id', 'name']
          },
          sites: 'default'
        },
        membershipDiscounts: {
          discount: 'default',
          membershipTiers: {
            fields: ['id', 'name']
          },
          membershipTierIds: 'default',
          sites: 'default'
        }
      },
      discounts: {
        items: 'default',
        itemVariations: 'default',
        itemClasses: 'default',
        movieIds: 'default',
        showingIds: 'default',
        titleClasses: 'default',
        ticketTypes: 'default',
        membershipTypes: 'default',
        voucherTypes: 'default',
        sites: 'default'
      },

      items: {
        taxes: 'default',
        itemClass: 'default',
        category: 'default',
        preparationCategory: 'default',
        itemVariations: 'default',
        locations: 'default',
        itemModifierSets: {
          modifierSet: 'default',
          defaultModifiers: 'default'
        }
      },
      itemVariations: {
        inventoryRecipes: {
          inventoryRecipeTriggers: true
        }
      },
      modifiers: {
        inventoryRecipes: {
          inventoryRecipeTriggers: true
        },
        modifierSets: true
      },
      modifierSets: {
        modifiers: {
          inventoryRecipes: {
            inventoryRecipeTriggers: true
          }
        }
      },
      taxes: {
        sites: 'default'
      },

      locations: {
        locationGroup: true
      },
      deliveryTypes: 'default',
      deliveryLocations: {
        pagerRequestTypes: 'default'
      },
      screens: {
        showingBadges: true
      },

      currentCircuit: {
        membershipTaxes: true,
        reservedSeatingShowingBadge: true,
        hasMembershipVouchers: true,
        sites: true
      },

      sites: {
        fields: ['id', 'name', 'hostname', 'isLibrary', 'city', 'state', 'zip', 'address1', 'lat', 'lon', 'siteDescription', 'consumerConfig', 'siteLocationZone', 'iso31661', 'displayOrder', 'timeZone', 'deletedAt']
      },

      currentSite: {
        ticketTaxes: true,
        dayPassTaxes: true,
        exchangeFeeTaxes: true,
        surchargeFeeTaxes: true,
        transformedStyles: true,
        hostname: true,
        isHostnameSharedAcrossSites: true,
        sharedHostnameSiteIdsByPath: true,
        stripeAccountId: true,
        linkEnabled: true,
        activeInventoryStrategy: {
          locations: true,
          registerStations: true,
          itemClasses: true
        }
      },

      publishedNewsItems: 'default',
      newsItemClasses: 'default',
      publishedPages: 'default',
      publishedGlobalWidgets: {
        visiblePageIds: true,
        globalWidgetBlocks: {
          navigations: {
            page: {
              fields: ['id', 'title', 'slug']
            }
          }
        }
      },
      navigations: {
        page: {
          fields: ['id', 'title', 'slug']
        }
      },
      siteLocationZones: 'default',
      activeMarketingSubscriptions: 'default'
    }
  }

  if (appMode === APP_MODE_TYPES.SIGNAGE) {
    clientConfigConfig = {
      ...clientConfigConfig,
      signageMediaClasses: 'default',

      currentSite: {
        enabledSignageMediaMovies: {
          allDatesWithPublicShowing: true
        },
        enabledSignageMediaItems: {
          signageMediaClass: 'default'
        }
      }
    }

    skipContext = true
  }

  return {
    skipContext,
    contextConfig,
    clientConfigConfig
  }
}

export default async function ({ app }) {
  for (const model of models) {
    await registerModel(model)
  }

  const {
    skipContext,
    contextConfig,
    clientConfigConfig
  } = buildConfigs(appMode)

  Model.configuration = new Model.ConfigurationType({}, clientConfigConfig)
  Model.context = new Model.ContextType({}, contextConfig)

  Model.configuration.ensureLoaded(true, true)
  if (!skipContext) {
    Model.context.ensureLoaded(true)
  } else {
    Model.skipContext = true
  }

  Model.configuration.validateOnAppLaunch()
  Model.configuration.validatePeriodically()

  app.use(VueModel, { Model })

  if (hasActionCable) {
    await Model.context.ensureLoaded()
    const connectionScopeEstablished = ((isPos || isKiosk) && !_.isNil(Model.context.currentRegisterClient?.registerStationId)) ||
        (isKds && !_.isNil(Model.context.currentKdsClient?.kitchenDisplayId)) ||
        (!isPos && !isKiosk && !isKds && !_.isNil(Model.context.currentUser))

    if (connectionScopeEstablished) {
      Model.configuration.subscribeToRemoteModelChanges()
      app.$remoteCommands.subscribe()
      app.$modelFormLock.subscribe()
      app.config.globalProperties.$salesRestrictions.subscribe()
    }
  }
}
